import { getImpressionType } from "./utils";
import useAppSelector from "../../hooks/useAppSelector";
import useIsRemarketingSearch from "../../features/configuration/useIsRemarketingSearch";
import { useMemo } from "react";
export default function useImpressionType() {
    var _a = useAppSelector(function (state) { return state.configuration; }), experience = _a.experience, insuranceType = _a.insuranceType, isSavvyAgent = _a.isSavvyAgent;
    var isRemarketingSearch = useIsRemarketingSearch();
    var insuranceProduct = useAppSelector(function (state) { return state.applicant.insuranceProduct; });
    return useMemo(function () {
        return getImpressionType({
            isRemarketingSearch: isRemarketingSearch,
            experience: experience,
            insuranceType: insuranceType,
            insuranceProduct: insuranceProduct,
            isSavvyAgent: isSavvyAgent,
        });
    }, [
        isRemarketingSearch,
        experience,
        insuranceType,
        insuranceProduct,
        isSavvyAgent,
    ]);
}
